import { Box } from '@wix/design-system';
import {
  ChecklistSmall,
  ConfirmSmall,
  HeadingSmall,
  LongTextSmall,
  RefreshSmall,
  ShortTextSmall,
} from '@wix/wix-ui-icons-common';
import React from 'react';

import type { Prompt, PromptCollection, PromptsConfiguration } from './types';

const EmptyIcon = () => <Box flexShrink={0} width={18} height={18} />;

export const changeTonePrompts: Prompt[] = [
  {
    type: 'prompt',
    title: 'AIPlugin_Prompt_ChangeTone_Professional',
    promptSlug: 'change-tone',
    promptParams: {
      tone: 'professional',
    },
    icon: EmptyIcon,
  },
  {
    type: 'prompt',
    title: 'AIPlugin_Prompt_ChangeTone_Casual',
    promptSlug: 'change-tone',
    promptParams: {
      tone: 'casual',
    },
    icon: EmptyIcon,
  },
  {
    type: 'prompt',
    title: 'AIPlugin_Prompt_ChangeTone_Funny',
    promptSlug: 'change-tone',
    promptParams: {
      tone: 'funny',
    },
    icon: EmptyIcon,
  },
  {
    type: 'prompt',
    title: 'AIPlugin_Prompt_ChangeTone_Confident',
    promptSlug: 'change-tone',
    promptParams: {
      tone: 'confident',
    },
    icon: EmptyIcon,
  },
  {
    type: 'prompt',
    title: 'AIPlugin_Prompt_ChangeTone_Enthusiastic',
    promptSlug: 'change-tone',
    promptParams: {
      tone: 'enthusiastic',
    },
    icon: EmptyIcon,
  },
];

const summarizePrompt: Prompt = {
  type: 'prompt',
  title: 'AIPlugin_Prompt_Summarize',
  promptSlug: 'summarize',
  icon: ChecklistSmall,
};

const generateHeadingPrompt: Prompt = {
  type: 'prompt',
  title: 'AIPlugin_Prompt_GenerateHeading',
  promptSlug: 'generate-heading',
  icon: HeadingSmall,
  sortResultActionsFn: (a, b) => {
    if (a.type === 'action' && a.name === 'insert-above') {
      return -1;
    }

    if (b.type === 'action' && b.name === 'insert-above') {
      return 1;
    }

    return 0;
  },
};

export const rephrasePrompt: Prompt = {
  type: 'prompt',
  title: 'AIPlugin_Prompt_Rephrase',
  promptSlug: 'rephrase',
  icon: RefreshSmall,
};

const fixSpellingAndGrammarPrompt: Prompt = {
  type: 'prompt',
  title: 'AIPlugin_Prompt_FixSpellingAndGrammar',
  promptSlug: 'fix-spelling-and-grammar',
  icon: ConfirmSmall,
};

export const makeShorterPrompt: Prompt = {
  type: 'prompt',
  title: 'AIPlugin_Prompt_MakeShorter',
  promptSlug: 'make-shorter',
  icon: ShortTextSmall,
};

export const makeLongerPrompt: Prompt = {
  type: 'prompt',
  title: 'AIPlugin_Prompt_MakeLonger',
  promptSlug: 'make-longer',
  icon: LongTextSmall,
};

const selectionPrompts: PromptCollection = [
  rephrasePrompt,
  fixSpellingAndGrammarPrompt,
  makeShorterPrompt,
  makeLongerPrompt,
  { type: 'section', title: 'AIPlugin_Prompts_Section_Generate' },
  summarizePrompt,
  generateHeadingPrompt,
  { type: 'section', title: 'AIPlugin_Prompts_Section_ChangeTone' },
  ...changeTonePrompts,
];

const floatingToolbarButtonPrompts: PromptCollection = [
  { type: 'section', title: 'AIPlugin_Prompts_Section_Adjust' },
  rephrasePrompt,
  fixSpellingAndGrammarPrompt,
  makeShorterPrompt,
  makeLongerPrompt,
  { type: 'section', title: 'AIPlugin_Prompts_Section_Generate' },
  summarizePrompt,
  generateHeadingPrompt,
  { type: 'section', title: 'AIPlugin_Prompts_Section_ChangeTone' },
  ...changeTonePrompts,
];

export const defaultPromptsConfiguration: PromptsConfiguration = {
  selectionPrompts,
  floatingToolbarButtonPrompts,
};
